import { Suspense, lazy } from 'react';
const Loading = <div>Loading....</div>;
const Mypage = lazy(() => import('../pages/mypage/MyPage'));

const memberRouter = () => {
  return [
    {
      path: '',
      element: (
        <Suspense fallback={Loading}>
          <Mypage />
        </Suspense>
      ),
    },
    {
      path: ':section',
      element: (
        <Suspense fallback={Loading}>
          <Mypage />
        </Suspense>
      ),
    },
  ];
};

export default memberRouter;
